var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { guard } from 'lit/directives/guard.js';
import { SdsLoadMoreBase } from '../../load-more/_sds-load-more-base.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsTreeNodeBase } from './_sds-tree-node-base';
import styles from './sds-tree-load-more-node.lit.scss';
import { colCountWithOffset } from './utilities';
/**
 * Control that represents a load more node.
 *
 * @tag sds-tree-load-more-node
 */
let SdsTreeLoadMoreNode = (() => {
    var _SdsTreeLoadMoreNode_selected_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tree-load-more-node')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsLoadMoreBase(SdsTreeNodeBase);
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    var SdsTreeLoadMoreNode = _classThis = class extends _classSuper {
        /**
         * Indicates whether this node is selected.
         */
        get selected() { return __classPrivateFieldGet(this, _SdsTreeLoadMoreNode_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsTreeLoadMoreNode_selected_accessor_storage, value, "f"); }
        constructor() {
            super();
            _SdsTreeLoadMoreNode_selected_accessor_storage.set(this, __runInitializers(this, _selected_initializers, false));
            __runInitializers(this, _selected_extraInitializers);
            this.isLeaf = true;
        }
        get gridColumnBorderPosition() {
            return colCountWithOffset(this.frozenColumns === 0 ? 1 : this.frozenColumns) + 1;
        }
        get hasFrozenColumns() {
            return this.frozenColumns !== 0;
        }
        /**
         * Adds a border to the node to indicate it has scrolled.
         */
        addBorderOnScroll() {
            this.classList.add('sds-tree-cell__scroll-border');
        }
        /**
         * Removes the border from the node indicating it is no longer scrolling.
         */
        removeBorderOnScroll() {
            this.classList.remove('sds-tree-cell__scroll-border');
        }
        /**
         * Freezes a specified number of columns in the node.
         * @param {number} count - The number of columns to freeze.
         */
        freezeColumns(count) {
            if (count !== 0) {
                this.classList.add('sds-tree-load-more-node__frozen');
            }
        }
        /**
         * Unfreezes all the columns in the node.
         */
        unFreezeAllColumns() {
            this.classList.remove('sds-tree-load-more-node__frozen');
        }
        /**
         * Returns the end position for the action container.
         * @protected
         * @returns {number} The end position of the action container.
         */
        actionEnd() {
            return this.gridColumnBorderPosition;
        }
        /**
         * Returns the start position for the info container.
         * @protected
         * @returns {number} The start position of the info container.
         */
        infoStart() {
            return this.gridColumnBorderPosition;
        }
        /**
         * Returns the end position for the info container.
         * @private
         * @returns {number} The end position of the info container.
         */
        infoEnd() {
            return colCountWithOffset(this.columns) + 1;
        }
        render() {
            var _a, _b;
            // prettier-ignore
            return html `
            ${guard([this.level, this.documentDir], () => this.pathStyles(this.level, this.documentDir))}
            <style>
                .action-container {
                    grid-column: 4/${this.actionEnd()};
                    ${this.hasFrozenColumns ? 'position: sticky' : undefined}
                }
            </style>
            <style>
                .info-container {
                    grid-column: ${this.infoStart()}/${this.infoEnd()};
                }
            </style>
            <style>
                .action-container {
                    padding-${this.documentDir === 'ltr' ? 'left' : 'right'}: ${12 + 40 * (this.level - 2)}px !important;
                }
            </style>
            <div></div>
            ${this.level === 1
                ? this.renderSinglePath(this.isCollapsed, this.isLeaf)
                : html `${this.renderPassingPaths(this.nodeId !== undefined
                    ? (_b = (_a = this.tree) === null || _a === void 0 ? void 0 : _a.hierarchicalState) === null || _b === void 0 ? void 0 : _b.getNode(this.nodeId)
                    : undefined)}
                      <div name="path" class="sds-tree-border sds-tree-border--right"></div>`}
            <div class="action-container">${this.renderButtons()}</div>
            <div class="info-container">${this.renderInfo()}</div>
        `;
        }
        /**
         * Changes the number of frozen columns in the node.
         * @protected
         * @param {number} newValue - The new value for the number of frozen columns.
         */
        changeFrozenColumns(newValue) {
            if (this.frozenColumns !== 0) {
                this.unFreezeAllColumns();
            }
            if (newValue !== 0) {
                this.freezeColumns(newValue);
            }
            super.changeFrozenColumns(newValue);
        }
    };
    _SdsTreeLoadMoreNode_selected_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTreeLoadMoreNode");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selected_decorators = [property({ type: Boolean, reflect: true })];
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeLoadMoreNode = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeLoadMoreNode = _classThis;
})();
export { SdsTreeLoadMoreNode };
